import { applyFormat } from "components/ui/ui-helpers";

const DetailCotisationsCarpv = (props) => {
  const { DetailCotisations, DetailCSG, TotalChargesSociales } = props;

  // Icônes spécifiques pour les cotisations CARPV
  const getIconStyle = (type) => {
    const icons = {
      maladie: { emoji: '🏥', background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' },
      famille: { emoji: '👨‍👩‍👧‍👦', background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' },
      ij: { emoji: '🏥', background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' },
      prevoyance: { emoji: '🦽', background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)' },
      retraite: { emoji: '☀️', background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)' },
      retraite_comp: { emoji: '🌴', background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' },
      formation: { emoji: '🎓', background: 'linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)' },
      csg: { emoji: '💰', background: 'linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)' }
    };
    return icons[type] || { emoji: '📊', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' };
  };

  return (
    <>
      <div className="cotisations-container">
        <div className="cotisations-list-container">
          <div className="cotisations-header">
            <div className="header-column"></div>
            <div className="header-column">Type de cotisation</div>
            <div className="header-column">Assiette</div>
            <div className="header-column">Taux</div>
            <div className="header-column">Montant dû</div>
          </div>
          
          <div className="cotisations-card light-title">
            <div 
              className="cotisations-card-icon" 
              style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)', color: '#4f46e5' }}
            >
              📊
            </div>
            <div className="card-column">Cotisations  {props.Prenom}</div>
            <div className="card-column"></div>
            <div className="card-column"></div>
            <div className="card-column"></div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('maladie').background }}
            >
              {getIconStyle('maladie').emoji}
            </div>
            <div className="card-column">Assurance maladie tranche 1</div>
            <div className="card-column">{DetailCotisations?.assiette_assurance_maladie}</div>
            <div className="card-column">{DetailCotisations?.taux_assurance_maladie}</div>
            <div className="card-column">{DetailCotisations?.assurance_maladie}</div>
          </div>
          
          {DetailCotisations?.assurance_maladie2 !== "0 €" && (
            <div className="cotisations-card">
              <div 
                className="cotisations-card-icon" 
                style={{ background: getIconStyle('maladie').background }}
              >
                {getIconStyle('maladie').emoji}
              </div>
              <div className="card-column">Assurance maladie tranche 2</div>
              <div className="card-column">{DetailCotisations?.assiette_assurance_maladie2}</div>
              <div className="card-column">{DetailCotisations?.taux_assurance_maladieT2}</div>
              <div className="card-column">{DetailCotisations?.assurance_maladie2}</div>
            </div>
          )}
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('famille').background }}
            >
              {getIconStyle('famille').emoji}
            </div>
            <div className="card-column">Allocations familiales</div>
            <div className="card-column">{DetailCotisations?.assiette_allocation_familiale}</div>
            <div className="card-column">{DetailCotisations?.taux_allocation_familiale}</div>
            <div className="card-column">{DetailCotisations?.allocation_familiale}</div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('ij').background }}
            >
              {getIconStyle('ij').emoji}
            </div>
            <div className="card-column">Indemnités journalières</div>
            <div className="card-column">{DetailCotisations?.assiette_ij_cpam}</div>
            <div className="card-column">{DetailCotisations?.taux_ij_cpam}</div>
            <div className="card-column">{DetailCotisations?.ij_cpam}</div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('prevoyance').background }}
            >
              {getIconStyle('prevoyance').emoji}
            </div>
            <div className="card-column">Invalidité / Décès</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.prevoyance}</div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('retraite').background }}
            >
              {getIconStyle('retraite').emoji}
            </div>
            <div className="card-column">Retraite de base tranche 1</div>
            <div className="card-column">{DetailCotisations?.assiette_retraite_de_base1}</div>
            <div className="card-column">{DetailCotisations?.taux_retraite_de_base1}</div>
            <div className="card-column">{DetailCotisations?.retraite_de_base1}</div>
          </div>
          
          {DetailCotisations?.retraite_de_base2 !== "0 €" && (
            <div className="cotisations-card">
              <div 
                className="cotisations-card-icon" 
                style={{ background: getIconStyle('retraite').background }}
              >
                {getIconStyle('retraite').emoji}
              </div>
              <div className="card-column">Retraite de base tranche 2</div>
              <div className="card-column">{DetailCotisations?.assiette_retraite_de_base2}</div>
              <div className="card-column">{DetailCotisations?.taux_retraite_de_base2}</div>
              <div className="card-column">{DetailCotisations?.retraite_de_base2}</div>
            </div>
          )}
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('retraite_comp').background }}
            >
              {getIconStyle('retraite_comp').emoji}
            </div>
            <div className="card-column">Retraite complémentaire</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.retraite_complementaire}</div>
          </div>
          
          <div className="cotisations-card light-title">
            <div 
              className="cotisations-card-icon" 
              style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)', color: '#4f46e5' }}
            >
              📊
            </div>
            <div className="card-column" style={{ gridColumn: '2 / 5' }}>
              Cotisations sociales obligatoires <span style={{ fontSize: "12px" }}>&nbsp;(hors formation et CSG-CRDS)</span>
            </div>
            <div className="card-column">
              {applyFormat(DetailCSG?.ChargesSocialesObligatoire, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('formation').background }}
            >
              {getIconStyle('formation').emoji}
            </div>
            <div className="card-column">Formation professionnelle</div>
            <div className="card-column">{DetailCotisations?.assiette_formation_professionnelle}</div>
            <div className="card-column">{DetailCotisations?.taux_formation_professionnelle}</div>
            <div className="card-column">{DetailCotisations?.formation_professionnelle}</div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('csg').background }}
            >
              {getIconStyle('csg').emoji}
            </div>
            <div className="card-column">CSG déductible</div>
            <div className="card-column">{applyFormat(DetailCSG?.assiette_csg, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.TauxCSGDeductible, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          
          <div className="cotisations-card">
            <div 
              className="cotisations-card-icon" 
              style={{ background: getIconStyle('csg').background }}
            >
              {getIconStyle('csg').emoji}
            </div>
            <div className="card-column">CSG non déductible + CRDS</div>
            <div className="card-column">{applyFormat(DetailCSG?.assiette_csg, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.TauxCSGNonDeductible, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_non_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          
          {Number(DetailCSG?.csg_primes) > 0 && (
            <div className="cotisations-card">
              <div 
                className="cotisations-card-icon" 
                style={{ background: getIconStyle('csg').background }}
              >
                {getIconStyle('csg').emoji}
              </div>
              <div className="card-column">CSG non déductible + CRDS sur épargne salariale</div>
              <div className="card-column">{applyFormat(DetailCSG?.assiette_csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
              <div className="card-column">{applyFormat(DetailCSG?.TauxCSG, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
              <div className="card-column">{applyFormat(DetailCSG?.csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          )}
          
          <div className="cotisations-card light-title">
            <div 
              className="cotisations-card-icon" 
              style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)', color: '#22c55e' }}
            >
              💰
            </div>
            <div className="card-column" style={{ gridColumn: '2 / 5' }}>
              Total des cotisations sociales
            </div>
            <div className="card-column">
              {applyFormat(TotalChargesSociales, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailCotisationsCarpv;
